var faqWrapp = document.querySelectorAll("[data-faq]");
if (faqWrapp) {
    faqWrapp && faqWrapp.forEach((function (e) {
        e.addEventListener("click", (function (e) {
            var t = e.currentTarget, n = e.target, o = t.querySelector("[data-faq-question]"),
                c = t.querySelector("[data-faq-answer]");
            n === o && (c.classList.toggle("active"), o.classList.toggle("active"))
        }))
    }));
}